import { PayloadAction } from '@reduxjs/toolkit'
import { StudioState } from '../initialState'
import EntityInterface from 'Vendor/Definition/EntityInterface'

export const collectionReducers = {
    collectionItemsSelected: (
        state: StudioState,
        action: PayloadAction<{
            creationId: number
            collectionSlug: string
            selectedItems: EntityInterface[]
        }>,
    ) => {
        const { creationId, collectionSlug, selectedItems } = action.payload

        if (!state.selectedItemsByCollection[creationId]) {
            state.selectedItemsByCollection[creationId] = {}
        }

        state.selectedItemsByCollection[creationId][collectionSlug] =
            selectedItems
    },

    ensureItemInCollection: (
        state: StudioState,
        action: PayloadAction<{
            creationId: number
            collectionSlug: string
            item: EntityInterface & { id: number | string }
        }>,
    ) => {
        const { creationId, collectionSlug, item } = action.payload
        if (!state.selectedItemsByCollection[creationId]) {
            state.selectedItemsByCollection[creationId] = {}
        }
        const collectionList =
            state.selectedItemsByCollection[creationId][collectionSlug] || []
        const itemExists = collectionList.some(
            (existingItem) => existingItem.id === item.id,
        )
        if (!itemExists) {
            state.selectedItemsByCollection[creationId][collectionSlug] = [
                ...collectionList,
                item,
            ]
        }
    },
    setCreationData: (state: StudioState, action: PayloadAction<any>) => {
        const creationId = action.payload.id
        state.creationId = creationId

        if (!state.selectedItemsByCollection[creationId]) {
            state.selectedItemsByCollection[creationId] = {}
        }
    },
}
